// This component differs from the GradeSelect by grouping grade levels
// into "småtrinn" (1.-4.) and "mellomtrinn" (5.-7.)

import { type LanguageTheme, allLanguageThemes } from "@arbeidsark/shared"
import { Select, type SelectOption, type SelectProps } from "~/components"
import { useTranslate } from "~/ur-react-hooks"

export interface LanguageThemeProps
  extends Omit<SelectProps<LanguageTheme>, "options"> {
  filterToThemes?: LanguageTheme[]
}

const LanguageThemeSelect: React.FC<LanguageThemeProps> = ({
  filterToThemes,
  ...props
}) => {
  const translations = useTranslate({
    birds: "worksheets.language-theme.birds",
    bugs: "worksheets.language-theme.bugs",
    christmas: "worksheets.language-theme.christmas",
    colours: "worksheets.language-theme.colours",
    clothes: "worksheets.language-theme.clothes",
    farmAnimals: "worksheets.language-theme.farm-animals",
    forestAnimals: "worksheets.language-theme.forest-animals",
    fruitsAndBerries: "worksheets.language-theme.fruits-and-berries",
    months: "worksheets.language-theme.months",
    myFamily: "worksheets.language-theme.my-family",
    myHouse: "worksheets.language-theme.my-house",
    space: "worksheets.language-theme.space",
    theBodyExternal: "worksheets.language-theme.the-body-external",
    theBodyInternal: "worksheets.language-theme.the-body-internal",
    vegetables: "worksheets.language-theme.vegetables",
    waterSeashore: "worksheets.language-theme.water-seashore",
    weatherAndSeasons: "worksheets.language-theme.weather-and-seasons",
    weekdays: "worksheets.language-theme.weekdays",
  })

  const baseOptions: SelectOption<LanguageTheme>[] = allLanguageThemes.map(
    (theme) => ({
      value: theme,
      label: translations[theme],
    }),
  )

  const filteredOptions = filterToThemes
    ? baseOptions.filter((option) => filterToThemes.includes(option.value))
    : baseOptions

  return <Select {...props} options={filteredOptions} />
}

export default LanguageThemeSelect
